/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { SofincoTokenResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * SofincoApi - axios parameter creator
 * @export
 */
export const SofincoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the token from Sofinco.
         * @summary getSofincoToken
         * @param {string} storeId The store identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sofinco: async (storeId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('sofinco', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/resources/payment/getSofincoToken`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SofincoApi - functional programming interface
 * @export
 */
export const SofincoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SofincoApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the token from Sofinco.
         * @summary getSofincoToken
         * @param {string} storeId The store identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sofinco(storeId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SofincoTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sofinco(storeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SofincoApi - factory interface
 * @export
 */
export const SofincoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SofincoApiFp(configuration)
    return {
        /**
         * Get the token from Sofinco.
         * @summary getSofincoToken
         * @param {string} storeId The store identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sofinco(storeId: string, options?: any): AxiosPromise<SofincoTokenResponse> {
            return localVarFp.sofinco(storeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SofincoApi - object-oriented interface
 * @export
 * @class SofincoApi
 * @extends {BaseAPI}
 */
export class SofincoApi extends BaseAPI {
    /**
     * Get the token from Sofinco.
     * @summary getSofincoToken
     * @param {string} storeId The store identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SofincoApi
     */
    public sofinco(storeId: string, options?: any) {
        return SofincoApiFp(this.configuration).sofinco(storeId, options).then((request) => request(this.axios, this.basePath));
    }
}
